// Google Analytics Utility
export const initializeGoogleAnalytics = () => {
    // Create script elements
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-T7Z8Z0SXWY';
  
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-T7Z8Z0SXWY');
    `;
  
    // Append scripts to document head
    document.head.appendChild(script1);
    document.head.appendChild(script2);
  };